/*
 * Public API Surface of angular-signature-pad
 */

export * from './lib/angular-signature-pad.component';
export * from './lib/angular-signature-pad.module';
